import { atom } from 'jotai';
import _ from 'lodash';
import queryString from 'query-string';
import jwtDecode, { JwtPayload } from 'jwt-decode';
import Cookies from 'js-cookie';
import { COOKIENAME } from '../config';

type IAuth = {
  insider_id: number;
  app_id: number;
  shop_id: number;
  email: string;
  myharavan_domain: string;
  expired_at: string;
};

export let defaultAuth: IAuth | null = null;

try {
  const query = queryString.parse(window.location.search);
  if (_.isString(query.token)) {
    Cookies.set(COOKIENAME, query.token, { expires: 0.75 });
  }
  const token = Cookies.get(COOKIENAME);
  if (!_.isString(token)) {
    throw Error('miss token');
  }
  const payload = jwtDecode<JwtPayload & IAuth>(token);
  defaultAuth = {
    insider_id: payload.insider_id,
    app_id: payload.app_id,
    shop_id: payload.shop_id,
    email: payload.email,
    myharavan_domain: payload.myharavan_domain,
    expired_at: payload.expired_at,
  };
} catch (e) {
  console.log(_.toString(e));
}

const authAtom = atom<IAuth | null>(defaultAuth);

export { authAtom };
